// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"FooterColumnGroup_footerLinks__MVUrQ","open":"FooterColumnGroup_open__Mx2B_"};